// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"3cc20349","309":"afc0a265","325":"45b352fe","417":"69db0632","454":"159b78c2","606":"d403f374","787":"5b459c87","862":"ab256146","920":"45287bfd"}[chunkId] + ".chunk.js";
};